module.exports = __webpack_public_path__ + "media/images/webpage/hotels/895/plan2-2-a2940b6c42cd8928aa37ad11e408edda.webp";